export default "/images/0744a27bc518cb5003b5235a6f784856.avif";